import React from 'react';
import { Input, Menu, Popover, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { dropdownMenuItemsObj, NEW_MODEL, PACKAGE_DIE } from '../../../../../services/Andes_v2/channel/channelBuilder/constant';
import { checkNameFormat } from '../../../../../services/helper/nameFormatCheck';
import { getDefaultName } from '../../../../../services/helper/setDefaultName';
import { PACKAGE } from '../../../../../constants/designType';
import { DIE } from '../../../../../constants/componentType';

/**
 * @description add model popover
 * @param {{
 * type: string
 * popoverKey: string, 
 * designType: string,
 * serdesType: string,
 * className: string, 
 * dropdownVisible: string,
 * modelTypeList: Array<string>,
 * addNewModel: (modelType: string) => void,
 * onOpenChange: (open: boolean) => void,
 * }} props 
 */
class AddNewModelPopover extends React.Component {
  constructor() {
    super();
    this.state = {
      inputValue: "",
      inputError: "",
      creatingModel: false
    }
  }

  cancelCreate = (e) => {
    e && e.stopPropagation();
    this.setState({ inputValue: "", creatingModel: false, inputError: "" });
  }

  createConfirm = (e) => {
    e.stopPropagation();
    const { inputValue } = this.state;
    // const { modelTypeList } = this.props;
    const error = checkNameFormat(inputValue, { errorType: "Model Name", allowEmpty: true });
    if (error) {
      this.setState({ inputError: error });
      this.inputRef.focus();
      return;
    }
    // if (modelTypeList.includes(inputValue)) {
    //   this.setState({ inputError: `${inputValue} already exists!` });
    //   this.inputRef.focus();
    //   return;
    // }
    this.props.addNewModel(inputValue);
    this.cancelCreate();
  }

  clickMenuItem = (e, modelType) => {
    e && e.stopPropagation();
    if (modelType === NEW_MODEL) {
      const { modelTypeList } = this.props;
      const defaultName = getDefaultName({
        nameList: modelTypeList,
        key: null,
        defaultKey: `Custom`
      })
      this.setState({ creatingModel: true, inputValue: defaultName });
      return;
    }

    this.onOpenChange();
    this.props.addNewModel(modelType);
  }

  onOpenChange = (open) => {
    this.props.onOpenChange(open);
    if (!open) {
      this.cancelCreate();
    }
  }

  render() {
    const { inputValue, creatingModel, inputError } = this.state;
    const { popoverKey, className, dropdownVisible, comps, designType } = this.props;
    return <Popover
      placement="bottom"
      arrow={false}
      content={
        <Menu
          mode='vertical'
          className='add-new-model-menu'
          selectable={false}
          items={comps.length === 0 ? []
            : [
              ...dropdownMenuItemsObj[designType === PACKAGE && comps[0].type === DIE ? PACKAGE_DIE : "default"],
              {
                label: !creatingModel ? <span className='create-new-model-add-model-span'>Generic...</span>
                  : <Tooltip title={inputError} open={inputError ? true : false} classNames={{ root: "aurora-error-tooltip" }} zIndex={2001}>
                    <Input
                      ref={ref => this.inputRef = ref}
                      value={inputValue}
                      onChange={(e) => { this.setState({ inputValue: e.target.value }) }}
                      onPressEnter={(e) => this.createConfirm(e)}
                      placeholder='Model Name'
                      addonAfter={<>
                        <CheckOutlined
                          className='create-new-model-icon'
                          onClick={(e) => this.createConfirm(e)} />
                        <CloseOutlined
                          className='create-new-model-icon mg-r-8'
                          onClick={(e) => this.cancelCreate(e)} />
                      </>}
                    />
                  </Tooltip>,
                key: NEW_MODEL
              }
            ]}
          onClick={({ key: modelType, domEvent }) => this.clickMenuItem(domEvent, modelType)}
        />}
      trigger="click"
      open={dropdownVisible === popoverKey}
      onOpenChange={this.onOpenChange}
    >
      {['tx', 'rx'].includes(popoverKey) ? <PlusOutlined /> : <PlusCircleOutlined className={className} />}
    </Popover >
  }
}

export default AddNewModelPopover;